export default {
  codecanyonNarrowItemCard: '2oVLIOcfTLyg4g0mwqff0w',
  defaultSort: 'Dwpo9P97QdG7lkEAyStiMQ'
}
